import * as React from "react";
const SvgFiRrGasPumpSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-gas-pump-slash_svg__a)">
      <path
        fill="#062147"
        d="M15.843 20.249A5 5 0 0 1 11 24H5a5.006 5.006 0 0 1-5-5V6a1 1 0 1 1 2 0v3h2a1 1 0 0 1 0 2H2v8a3 3 0 0 0 3 3h6a3 3 0 0 0 2.9-2.249 1.001 1.001 0 1 1 1.938.5zM24 18a3 3 0 0 1-1.826 2.76l1.533 1.533a1 1 0 0 1-1.414 1.414l-22-22A1 1 0 0 1 1.707.293l.535.535A5 5 0 0 1 5 0h6a5.006 5.006 0 0 1 5 5v9.586L20.414 19H21a1 1 0 0 0 1-1V8a2 2 0 0 1-2-2V3.414l-1.707-1.707A1 1 0 0 1 19.707.293l1.99 1.99.02.02.525.525A5.96 5.96 0 0 1 24 6.945zm-10-7h-1.586L14 12.586zM3.707 2.293 10.414 9H14V5a3 3 0 0 0-3-3H5a3 3 0 0 0-1.293.293"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-gas-pump-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGasPumpSlash;
